import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ValidationAccordionWrapper } from "./ValidationAccordianStyled";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Button } from "@mui/material";
import TableSortLabel from "@mui/material/TableSortLabel";
export const ValidationAccordionComp = ({
    title,
    subtitle,
    headers,
    rows,
    countries,
    handleConfirm,
}) => {
    const [radioData, setRadioValue] = React.useState(Array(rows.length).fill(0));
    const [countryData, setCountryData] = useState(Array(rows.length).fill(""));   
    const handleSelectChange = (event, rowIndex) => {
        const newValue = event.target.value;      
        stableSort(rows, getComparator(order, orderBy))[rowIndex].variationName = newValue;
        stableSort(rows, getComparator(order, orderBy))[rowIndex].isVariation = false;
        setCountryData((prevCountryData) => {
            const updatedCountryData = [...prevCountryData];
            updatedCountryData[rowIndex] = newValue;
            return updatedCountryData;
        });
        
        setRadioValue((prevRadioValue) => {
            const updatedRadioValue = [...prevRadioValue];
            updatedRadioValue[rowIndex] = 2;
            radioData[rowIndex] = 2;
            console.log(updatedRadioValue, 'updated radio val');
            return updatedRadioValue;
        });
    };

    const handleRadioChange = (event, rowIndex) => {
        const newValue = event.target.value == "yes" ? 1 : 2;
        setRadioValue((prevRadioValue) => {
            const updatedRadioValue = [...prevRadioValue];
            updatedRadioValue[rowIndex] = newValue;
            console.log(updatedRadioValue);
            return updatedRadioValue;
        });
        stableSort(rows, getComparator(order, orderBy))[rowIndex].isVariation = event.target.value == "yes"?false:true;
        setCountryData((prevCountryData) => {
            const updatedCountryData = [...prevCountryData];
            updatedCountryData[rowIndex] = newValue;
            return updatedCountryData;
        });
        
    };
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState("Country");
    const createSortHandler = (property) => (event) => {
        setOrder(order == 'asc' ? 'desc' : 'asc');
        setOrderBy(property);
    };
    function descendingComparator(a, b, orderBy) {
        let index=orderBy==="Country"?'countryName':'headCount'
        if (b[index] < a[index]) {
            return -1;
        }
        if (b[index] > a[index]) {
            return 1;
        }
        return 0;
    }
  
    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
  
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) {
                return order;
            }
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }
    return (
        <ValidationAccordionWrapper defaultExpanded={true}>
            <AccordionSummary
                className="accordian"
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{title}</Typography>
                <span aria-required>{subtitle}</span>
            </AccordionSummary>
            <AccordionDetails>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 400 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {headers.map((header) => (
                                    <TableCell>{header}
                                     {(header==='Country' || header==='HeadCount') && <TableSortLabel
                                            active={orderBy === header}
                                            direction={orderBy === header ? order : 'asc'}
                                            onClick={createSortHandler(header)}>
                                        </TableSortLabel>}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy)).map((row, rowIndex) => (
                                <TableRow key={rowIndex}>
                                    <TableCell>{(row.countryName)}</TableCell>
                                    <TableCell>{(row.headCount.toLocaleString())}</TableCell>
                                   {row.variationName == null || radioData[rowIndex] === 2 ?
                                         <TableCell><FormControl className="customDropdown">
                                            <Select
                                                value={countryData[rowIndex]}
                                                name="productId"
                                                onChange={(e) => handleSelectChange(e, rowIndex)}
                                                placeholder="Select"
                                            >
                                                <MenuItem value={0} disabled>Select</MenuItem>
                                                {countries.map((option) => (                                                     
                                                    <MenuItem key={option.id} value={option.countryName}>
                                                        {option.countryName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl></TableCell> 
                                        :
                                        
                                            radioData[rowIndex] === 1 ?
                                                < TableCell className="confirm">{(row.variationName)}</TableCell>
                                                :
                                                row.isVariation ?< TableCell className="error">{(row.variationName)}</TableCell>
                                            : <TableCell>{(row.variationName)}</TableCell>
                                    }

                                    <TableCell>{
                                        ((row.isVariation && row.variationName == null) || radioData[rowIndex] === 2 ? (<div className="error">Select country from the dropdown</div>)
                                            : (row.isVariation && row.variationName !== null ?
                                                (
                                                    radioData[rowIndex] === 0 ? (
                                                        <div className="confirmation">
                                                            <div>Confirm Correction</div>
                                                            <RadioGroup
                                                                row
                                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                                name="controlled-radio-buttons-group"
                                                                value={radioData[rowIndex]}
                                                                onChange={(e) => handleRadioChange(e, rowIndex)}
                                                            >
                                                                <FormControlLabel
                                                                    value="yes"
                                                                    control={<Radio size="small" />}
                                                                    label="Yes"
                                                                />
                                                                <FormControlLabel
                                                                    value="no"
                                                                    control={<Radio size="small" />}
                                                                    label="No"
                                                                />
                                                            </RadioGroup>
                                                        </div>
                                                    ) : ("-")
                                                ) : ("-")

                                            ))}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div>
                    <Button variant="contained" onClick={handleConfirm}>
                        Confirm Corrections
                    </Button>
                </div>
            </AccordionDetails>
        </ValidationAccordionWrapper>
    );
};

export default ValidationAccordionComp;
